import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    FormControlLabel,
    FormHelperText,
    InputLabel,
    Paper,
    Radio,
    RadioGroup,
    Tab,
    Tabs,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getIsEmailTemplateForm } from "../../Utils";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getUserRole } from "../../redux/selector";
import ReoEmailTemplate from "./ReoEmailTemplate";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            // aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        // id: `simple-tab-${index}`,
        // htmlFor: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles({
    heading: {
        paddingLeft: "20px",
        flexBasis: "33.33%",
        flexShrink: 0,
    },
    secondaryHeading: {
        color: "#606060",
    },
    accordionTab: {
        minWidth: "100px",
    },
    hideTab: {
        display: "none",
        width: 0,
        height: 0,
    },
});

function EmailTemplate({
    dataList,
    errors,
    register,
    role,
    // emailRole,
    handleRadioChange,
    allItem,
    control,
    watch,
    selectedForm,
    formLayerNum,
}) {
    const { t, i18n } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const handleAccordionChange =
        (panel, value, index) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
            if (value > 6 && index != 5) {
                setValue(0);
            }
        };

    function EnableEmailNoti(index, fieldName, item, tabValue, language) {
        let emailFieldName =
            fieldName === "reviewer"
                ? "EdbReviewer"
                : fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
        console.log("--------", emailFieldName);
        return (
            <React.Fragment key={language}>
                {selectedForm !== 14 && (
                    <Controller
                        control={control}
                        name={`emailContent.${index}.enable${emailFieldName}`}
                        render={({ field }) => (
                            <RadioGroup
                                aria-label={`emailContent.${index}.enable${emailFieldName}`}
                                value={field.value}
                                onChange={(e) => {
                                    field.onChange(e.target.value);
                                    handleRadioChange(
                                        e,
                                        `emailContent.${index}.enable${emailFieldName}`
                                    );
                                }}
                                row
                            >
                                <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label={t("common.portal.enable")}
                                />
                                <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label={t("common.portal.disable")}
                                />
                            </RadioGroup>
                        )}
                    />
                )}

                <Typography variant="h6" component="h2">
                    {t("common.portal.emailTitle")}
                </Typography>
                <InputLabel
                    htmlFor={
                        language === "tc"
                            ? `emailContent.${index}.title${emailFieldName.replace(
                                  "Edb",
                                  ""
                              )}TC`
                            : language === "sc"
                            ? `emailContent.${index}.title${emailFieldName.replace(
                                  "Edb",
                                  ""
                              )}SC`
                            : `emailContent.${index}.title${emailFieldName.replace(
                                  "Edb",
                                  ""
                              )}`
                    }
                    style={{
                        display: "none",
                    }}
                >
                    {t("common.portal.emailTitle")}
                </InputLabel>
                <CustomTextField
                    fullWidth
                    inputProps={register(
                        language === "tc"
                            ? `emailContent.${index}.title${emailFieldName.replace(
                                  "Edb",
                                  ""
                              )}TC`
                            : language === "sc"
                            ? `emailContent.${index}.title${emailFieldName.replace(
                                  "Edb",
                                  ""
                              )}SC`
                            : `emailContent.${index}.title${emailFieldName.replace(
                                  "Edb",
                                  ""
                              )}`,
                        {
                            required: t("errorMsg.required"),
                            validate: {
                                stringInclude: (v) =>
                                    tabValue == 7 ||
                                    tabValue == 8 ||
                                    tabValue == 9 ||
                                    tabValue == 11
                                        ? true
                                        : v.includes(unchangedTitleNum) ||
                                          "Ref Num needs to be kept of EmailTemplate",
                            },
                        }
                    )}
                    onKeyUp={(e) => lockStringTitle(e, fieldName, index)}
                ></CustomTextField>
                <Typography
                    variant="h6"
                    style={{
                        marginTop: "1rem",
                    }}
                    component="h2"
                >
                    {t("common.portal.emailContent")}
                </Typography>
                <InputLabel
                    htmlFor={
                        language === "tc"
                            ? `emailContent.${index}.finalEmail${emailFieldName}InfoTC`
                            : language === "sc"
                            ? `emailContent.${index}.finalEmail${emailFieldName}InfoSC`
                            : `emailContent.${index}.finalEmail${emailFieldName}Info`
                    }
                    style={{
                        display: "none",
                    }}
                >
                    {t("common.portal.emailContent")}
                </InputLabel>
                <CustomTextField
                    fullWidth
                    multiline
                    rows={5}
                    defaultValue={
                        language === "tc"
                            ? `${item}.finalEmail${emailFieldName}InfoTC`
                            : language === "sc"
                            ? `${item}.finalEmail${emailFieldName}InfoSC`
                            : `${item}.finalEmail${emailFieldName}Info`
                    }
                    inputProps={register(
                        language === "tc"
                            ? `emailContent.${index}.finalEmail${emailFieldName}InfoTC`
                            : language === "sc"
                            ? `emailContent.${index}.finalEmail${emailFieldName}InfoSC`
                            : `emailContent.${index}.finalEmail${emailFieldName}Info`,
                        {
                            required: t("errorMsg.required"),
                            validate: {
                                stringInclude: (v) => {
                                    let templatePart = getIsEmailTemplateForm(
                                        selectedForm,
                                        tabValue,
                                        language,
                                        index
                                    );
                                    let tempCon = templatePart.content;
                                    return tabValue == 7 ||
                                        tabValue == 8 ||
                                        tabValue == 9 ||
                                        tabValue == 11
                                        ? true
                                        : v.includes(tempCon) ||
                                              "Url link and Ref Num needs to be kept of EmailTemplate";
                                },
                            },
                        }
                    )}
                    onKeyUp={(e) => inputWithLockString(e, fieldName, index)}
                ></CustomTextField>
                <FormHelperText>
                    <ErrorMsg message={errors} />
                </FormHelperText>
            </React.Fragment>
        );
    }

    const classes = useStyles();
    const [unchangedPart, setUnchangedPart] = useState("");
    const [unchangedTitleNum, setUnchangedTitleNum] = useState("");
    const [preservedText, setPreservedText] = useState([]);
    const [preservedTextAp, setPreservedTextAp] = useState([]);
    const [preservedTextSecAp, setPreservedTextSecAp] = useState([]);
    const [preservedTextThirdAp, setPreservedTextThirdAp] = useState([]);
    const [preservedTextFourthAp, setPreservedTextFourthAp] = useState([]);
    const [preservedTextRev, setPreservedTextRev] = useState([]);
    const [preservedTextOwner, setPreservedTextOwner] = useState([]);
    const [preservedTextSsdo, setPreservedTextSsdo] = useState([]);
    const [preservedTextSdo, setPreservedTextSdo] = useState([]);
    const [preservedTextCsdo, setPreservedTextCsdo] = useState([]);
    const [preservedTextServo, setPreservedTextServo] = useState([]);
    const [preservedTextClerStaff, setPreservedTextClerStaff] = useState([]);
    const [preservedTitle, setPreservedTitle] = useState([]);
    const [preservedTitleAp, setPreservedTitleAp] = useState([]);
    const [preservedTitleSecAp, setPreservedTitleSecAp] = useState([]);
    const [preservedTitleThirdAp, setPreservedTitleThirdAp] = useState([]);
    const [preservedTitleFourthAp, setPreservedTitleFourthAp] = useState([]);
    const [preservedTitleRev, setPreservedTitleRev] = useState([]);
    const [preservedTitleOwner, setPreservedTitleOwner] = useState([]);
    const [preservedTitleSsdo, setPreservedTitleSsdo] = useState([]);
    const [preservedTitleSdo, setPreservedTitleSdo] = useState([]);
    const [preservedTitleCsdo, setPreservedTitleCsdo] = useState([]);
    const [preservedTitleServo, setPreservedTitleServo] = useState([]);
    const [preservedTitleClerStaff, setPreservedTitleClerStaff] = useState([]);

    useEffect(() => {
        if (allItem != undefined) {
            if (i18n.language === "tc") {
                //title
                setPreservedTitle([
                    allItem[0].titleApplicantTC, //applicant
                    allItem[1].titleApplicantTC, //approver
                    allItem[2].titleApplicantTC, //2nd approver
                    allItem[3].titleApplicantTC, //3rd approver
                    allItem[4].titleApplicantTC, //4rd approver
                    allItem[5].titleApplicantTC, //reviewer])
                    allItem[6].titleApplicantTC, //return
                    allItem[7].titleApplicantTC, //reject
                ]);
                setPreservedTitleAp([
                    allItem[0].titleApproverTC,
                    allItem[1].titleApproverTC,
                    allItem[2].titleApproverTC,
                    allItem[3].titleApproverTC,
                    allItem[4].titleApproverTC,
                    allItem[5].titleApproverTC,
                    allItem[6].titleApproverTC,
                    allItem[7].titleApproverTC,
                ]);
                setPreservedTitleSecAp([
                    allItem[0].titleSecondApproverTC,
                    allItem[1].titleSecondApproverTC,
                    allItem[2].titleSecondApproverTC,
                    allItem[3].titleSecondApproverTC,
                    allItem[4].titleSecondApproverTC,
                    allItem[5].titleSecondApproverTC,
                    allItem[6].titleSecondApproverTC,
                    allItem[7].titleSecondApproverTC,
                ]);
                setPreservedTitleThirdAp([
                    allItem[0].titleThirdApproverTC,
                    allItem[1].titleThirdApproverTC,
                    allItem[2].titleThirdApproverTC,
                    allItem[3].titleThirdApproverTC,
                    allItem[4].titleThirdApproverTC,
                    allItem[5].titleThirdApproverTC,
                    allItem[6].titleThirdApproverTC,
                    allItem[7].titleThirdApproverTC,
                ]);
                setPreservedTitleFourthAp([
                    allItem[0].titleFourthApproverTC,
                    allItem[1].titleFourthApproverTC,
                    allItem[2].titleFourthApproverTC,
                    allItem[3].titleFourthApproverTC,
                    allItem[4].titleFourthApproverTC,
                    allItem[5].titleFourthApproverTC,
                    allItem[6].titleFourthApproverTC,
                    allItem[7].titleFourthApproverTC,
                ]);
                setPreservedTitleRev([
                    allItem[0].titleReviewerTC,
                    allItem[1].titleReviewerTC,
                    allItem[2].titleReviewerTC,
                    allItem[3].titleReviewerTC,
                    allItem[4].titleReviewerTC,
                    allItem[5].titleReviewerTC,
                    allItem[6].titleReviewerTC,
                    allItem[7].titleReviewerTC,
                ]);
                setPreservedTitleOwner([
                    allItem[0].titleFormOwnerTC,
                    allItem[1].titleFormOwnerTC,
                    allItem[2].titleFormOwnerTC,
                    allItem[3].titleFormOwnerTC,
                    allItem[4].titleFormOwnerTC,
                    allItem[5].titleFormOwnerTC,
                    allItem[6].titleFormOwnerTC,
                    allItem[7].titleFormOwnerTC,
                ]);
                setPreservedTitleSsdo([
                    allItem[0]?.titleSsdo,
                    allItem[1]?.titleSsdo,
                    allItem[2]?.titleSsdo,
                    allItem[3]?.titleSsdo,
                    allItem[4]?.titleSsdo,
                    allItem[5]?.titleSsdo,
                    allItem[6]?.titleSsdo,
                    allItem[7]?.titleSsdo,
                ]);
                setPreservedTitleSdo([
                    allItem[0]?.titleSdo,
                    allItem[1]?.titleSdo,
                    allItem[2]?.titleSdo,
                    allItem[3]?.titleSdo,
                    allItem[4]?.titleSdo,
                    allItem[5]?.titleSdo,
                    allItem[6]?.titleSdo,
                    allItem[7]?.titleSdo,
                ]);
                setPreservedTitleCsdo([
                    allItem[0]?.titleCsdo,
                    allItem[1]?.titleCsdo,
                    allItem[2]?.titleCsdo,
                    allItem[3]?.titleCsdo,
                    allItem[4]?.titleCsdo,
                    allItem[5]?.titleCsdo,
                    allItem[6]?.titleCsdo,
                    allItem[7]?.titleCsdo,
                ]);
                setPreservedTitleServo([
                    allItem[0]?.titleServo,
                    allItem[1]?.titleServo,
                    allItem[2]?.titleServo,
                    allItem[3]?.titleServo,
                    allItem[4]?.titleServo,
                    allItem[5]?.titleServo,
                    allItem[6]?.titleServo,
                    allItem[7]?.titleServo,
                ]);
                setPreservedTitleClerStaff([
                    allItem[0]?.titleClerStaff,
                    allItem[1]?.titleClerStaff,
                    allItem[2]?.titleClerStaff,
                    allItem[3]?.titleClerStaff,
                    allItem[4]?.titleClerStaff,
                    allItem[5]?.titleClerStaff,
                    allItem[6]?.titleClerStaff,
                    allItem[7]?.titleClerStaff,
                ]);

                //content
                setPreservedText([
                    allItem[0].finalEmailApplicantInfoTC, //applicant
                    allItem[1].finalEmailApplicantInfoTC, //approver
                    allItem[2].finalEmailApplicantInfoTC, //2nd approver
                    allItem[3].finalEmailApplicantInfoTC, //3rd approver
                    allItem[4].finalEmailApplicantInfoTC, //4rd approver
                    allItem[5].finalEmailApplicantInfoTC, //reviewer
                    allItem[6].finalEmailApplicantInfoTC, //return
                    allItem[7].finalEmailApplicantInfoTC, //reject
                ]);
                setPreservedTextAp([
                    allItem[0].finalEmailApproverInfoTC,
                    allItem[1].finalEmailApproverInfoTC,
                    allItem[2].finalEmailApproverInfoTC,
                    allItem[3].finalEmailApproverInfoTC,
                    allItem[4].finalEmailApproverInfoTC,
                    allItem[5].finalEmailApproverInfoTC,
                    allItem[6].finalEmailApproverInfoTC,
                    allItem[7].finalEmailApproverInfoTC,
                ]);
                setPreservedTextSecAp([
                    allItem[0].finalEmailSecondApproverInfoTC,
                    allItem[1].finalEmailSecondApproverInfoTC,
                    allItem[2].finalEmailSecondApproverInfoTC,
                    allItem[3].finalEmailSecondApproverInfoTC,
                    allItem[4].finalEmailSecondApproverInfoTC,
                    allItem[5].finalEmailSecondApproverInfoTC,
                    allItem[6].finalEmailSecondApproverInfoTC,
                    allItem[7].finalEmailSecondApproverInfoTC,
                ]);
                setPreservedTextThirdAp([
                    allItem[0].finalEmailThirdApproverInfoTC,
                    allItem[1].finalEmailThirdApproverInfoTC,
                    allItem[2].finalEmailThirdApproverInfoTC,
                    allItem[3].finalEmailThirdApproverInfoTC,
                    allItem[4].finalEmailThirdApproverInfoTC,
                    allItem[5].finalEmailThirdApproverInfoTC,
                    allItem[6].finalEmailThirdApproverInfoTC,
                    allItem[7].finalEmailThirdApproverInfoTC,
                ]);
                setPreservedTextFourthAp([
                    allItem[0].finalEmailFourthApproverInfoTC,
                    allItem[1].finalEmailFourthApproverInfoTC,
                    allItem[2].finalEmailFourthApproverInfoTC,
                    allItem[3].finalEmailFourthApproverInfoTC,
                    allItem[4].finalEmailFourthApproverInfoTC,
                    allItem[5].finalEmailFourthApproverInfoTC,
                    allItem[6].finalEmailFourthApproverInfoTC,
                    allItem[7].finalEmailFourthApproverInfoTC,
                ]);
                setPreservedTextRev([
                    allItem[0].finalEmailEdbReviewerInfoTC,
                    allItem[1].finalEmailEdbReviewerInfoTC,
                    allItem[2].finalEmailEdbReviewerInfoTC,
                    allItem[3].finalEmailEdbReviewerInfoTC,
                    allItem[4].finalEmailEdbReviewerInfoTC,
                    allItem[5].finalEmailEdbReviewerInfoTC,
                    allItem[6].finalEmailEdbReviewerInfoTC,
                    allItem[7].finalEmailEdbReviewerInfoTC,
                ]);
                setPreservedTextOwner([
                    allItem[0].finalEmailFormOwnerInfoTC,
                    allItem[1].finalEmailFormOwnerInfoTC,
                    allItem[2].finalEmailFormOwnerInfoTC,
                    allItem[3].finalEmailFormOwnerInfoTC,
                    allItem[4].finalEmailFormOwnerInfoTC,
                    allItem[5].finalEmailFormOwnerInfoTC,
                    allItem[6].finalEmailFormOwnerInfoTC,
                    allItem[7].finalEmailFormOwnerInfoTC,
                ]);
                setPreservedTextSsdo([
                    allItem[0]?.finalEmailSsdoInfo,
                    allItem[1]?.finalEmailSsdoInfo,
                    allItem[2]?.finalEmailSsdoInfo,
                    allItem[3]?.finalEmailSsdoInfo,
                    allItem[4]?.finalEmailSsdoInfo,
                    allItem[5]?.finalEmailSsdoInfo,
                    allItem[6]?.finalEmailSsdoInfo,
                    allItem[7]?.finalEmailSsdoInfo,
                ]);
                setPreservedTextSdo([
                    allItem[0]?.finalEmailSdoInfo,
                    allItem[1]?.finalEmailSdoInfo,
                    allItem[2]?.finalEmailSdoInfo,
                    allItem[3]?.finalEmailSdoInfo,
                    allItem[4]?.finalEmailSdoInfo,
                    allItem[5]?.finalEmailSdoInfo,
                    allItem[6]?.finalEmailSdoInfo,
                    allItem[7]?.finalEmailSdoInfo,
                ]);
                setPreservedTextCsdo([
                    allItem[0]?.finalEmailCsdoInfo,
                    allItem[1]?.finalEmailCsdoInfo,
                    allItem[2]?.finalEmailCsdoInfo,
                    allItem[3]?.finalEmailCsdoInfo,
                    allItem[4]?.finalEmailCsdoInfo,
                    allItem[5]?.finalEmailCsdoInfo,
                    allItem[6]?.finalEmailCsdoInfo,
                    allItem[7]?.finalEmailCsdoInfo,
                ]);
                setPreservedTextServo([
                    allItem[0]?.finalEmailServoInfo,
                    allItem[1]?.finalEmailServoInfo,
                    allItem[2]?.finalEmailServoInfo,
                    allItem[3]?.finalEmailServoInfo,
                    allItem[4]?.finalEmailServoInfo,
                    allItem[5]?.finalEmailServoInfo,
                    allItem[6]?.finalEmailServoInfo,
                    allItem[7]?.finalEmailServoInfo,
                ]);
                setPreservedTextClerStaff([
                    allItem[0]?.finalEmailClerStaffInfo,
                    allItem[1]?.finalEmailClerStaffInfo,
                    allItem[2]?.finalEmailClerStaffInfo,
                    allItem[3]?.finalEmailClerStaffInfo,
                    allItem[4]?.finalEmailClerStaffInfo,
                    allItem[5]?.finalEmailClerStaffInfo,
                    allItem[6]?.finalEmailClerStaffInfo,
                    allItem[7]?.finalEmailClerStaffInfo,
                ]);
                // setUnchangedPart(urlLinkNRefNumTC);
            } else if (i18n.language === "sc") {
                setPreservedTitle([
                    allItem[0].titleApplicantSC, //applicant
                    allItem[1].titleApplicantSC, //approver
                    allItem[2].titleApplicantSC, //2nd approver
                    allItem[3].titleApplicantSC, //3rd approver
                    allItem[4].titleApplicantSC, //4rd approver
                    allItem[5].titleApplicantSC, //reviewer])
                    allItem[6].titleApplicantSC, //return
                    allItem[7].titleApplicantSC, //reject
                ]);
                setPreservedTitleAp([
                    allItem[0].titleApproverSC,
                    allItem[1].titleApproverSC,
                    allItem[2].titleApproverSC,
                    allItem[3].titleApproverSC,
                    allItem[4].titleApproverSC,
                    allItem[5].titleApproverSC,
                    allItem[6].titleApproverSC,
                    allItem[7].titleApproverSC,
                ]);
                setPreservedTitleSecAp([
                    allItem[0].titleSecondApproverSC,
                    allItem[1].titleSecondApproverSC,
                    allItem[2].titleSecondApproverSC,
                    allItem[3].titleSecondApproverSC,
                    allItem[4].titleSecondApproverSC,
                    allItem[5].titleSecondApproverSC,
                    allItem[6].titleSecondApproverSC,
                    allItem[7].titleSecondApproverSC,
                ]);
                setPreservedTitleThirdAp([
                    allItem[0].titleThirdApproverSC,
                    allItem[1].titleThirdApproverSC,
                    allItem[2].titleThirdApproverSC,
                    allItem[3].titleThirdApproverSC,
                    allItem[4].titleThirdApproverSC,
                    allItem[5].titleThirdApproverSC,
                    allItem[6].titleThirdApproverSC,
                    allItem[7].titleThirdApproverSC,
                ]);
                setPreservedTitleFourthAp([
                    allItem[0].titleFourthApproverSC,
                    allItem[1].titleFourthApproverSC,
                    allItem[2].titleFourthApproverSC,
                    allItem[3].titleFourthApproverSC,
                    allItem[4].titleFourthApproverSC,
                    allItem[5].titleFourthApproverSC,
                    allItem[6].titleFourthApproverSC,
                    allItem[7].titleFourthApproverSC,
                ]);
                setPreservedTitleRev([
                    allItem[0].titleReviewerSC,
                    allItem[1].titleReviewerSC,
                    allItem[2].titleReviewerSC,
                    allItem[3].titleReviewerSC,
                    allItem[4].titleReviewerSC,
                    allItem[5].titleReviewerSC,
                    allItem[6].titleReviewerSC,
                    allItem[7].titleReviewerSC,
                ]);
                setPreservedTitleOwner([
                    allItem[0].titleFormOwnerSC,
                    allItem[1].titleFormOwnerSC,
                    allItem[2].titleFormOwnerSC,
                    allItem[3].titleFormOwnerSC,
                    allItem[4].titleFormOwnerSC,
                    allItem[5].titleFormOwnerSC,
                    allItem[6].titleFormOwnerSC,
                    allItem[7].titleFormOwnerSC,
                ]);
                setPreservedTitleSsdo([
                    allItem[0]?.titleSsdo,
                    allItem[1]?.titleSsdo,
                    allItem[2]?.titleSsdo,
                    allItem[3]?.titleSsdo,
                    allItem[4]?.titleSsdo,
                    allItem[5]?.titleSsdo,
                    allItem[6]?.titleSsdo,
                    allItem[7]?.titleSsdo,
                ]);
                setPreservedTitleSdo([
                    allItem[0]?.titleSdo,
                    allItem[1]?.titleSdo,
                    allItem[2]?.titleSdo,
                    allItem[3]?.titleSdo,
                    allItem[4]?.titleSdo,
                    allItem[5]?.titleSdo,
                    allItem[6]?.titleSdo,
                    allItem[7]?.titleSdo,
                ]);
                setPreservedTitleCsdo([
                    allItem[0]?.titleCsdo,
                    allItem[1]?.titleCsdo,
                    allItem[2]?.titleCsdo,
                    allItem[3]?.titleCsdo,
                    allItem[4]?.titleCsdo,
                    allItem[5]?.titleCsdo,
                    allItem[6]?.titleCsdo,
                    allItem[7]?.titleCsdo,
                ]);
                setPreservedTitleServo([
                    allItem[0]?.titleServo,
                    allItem[1]?.titleServo,
                    allItem[2]?.titleServo,
                    allItem[3]?.titleServo,
                    allItem[4]?.titleServo,
                    allItem[5]?.titleServo,
                    allItem[6]?.titleServo,
                    allItem[7]?.titleServo,
                ]);
                setPreservedTitleClerStaff([
                    allItem[0]?.titleClerStaff,
                    allItem[1]?.titleClerStaff,
                    allItem[2]?.titleClerStaff,
                    allItem[3]?.titleClerStaff,
                    allItem[4]?.titleClerStaff,
                    allItem[5]?.titleClerStaff,
                    allItem[6]?.titleClerStaff,
                    allItem[7]?.titleClerStaff,
                ]);

                //content
                setPreservedText([
                    allItem[0].finalEmailApplicantInfoSC,
                    allItem[1].finalEmailApplicantInfoSC,
                    allItem[2].finalEmailApplicantInfoSC,
                    allItem[3].finalEmailApplicantInfoSC,
                    allItem[4].finalEmailApplicantInfoSC,
                    allItem[5].finalEmailApplicantInfoSC,
                    allItem[6].finalEmailApplicantInfoSC,
                    allItem[7].finalEmailApplicantInfoSC,
                ]);
                setPreservedTextAp([
                    allItem[0].finalEmailApproverInfoSC,
                    allItem[1].finalEmailApproverInfoSC,
                    allItem[2].finalEmailApproverInfoSC,
                    allItem[3].finalEmailApproverInfoSC,
                    allItem[4].finalEmailApproverInfoSC,
                    allItem[5].finalEmailApproverInfoSC,
                    allItem[6].finalEmailApproverInfoSC,
                    allItem[7].finalEmailApproverInfoSC,
                ]);
                setPreservedTextSecAp([
                    allItem[0].finalEmailSecondApproverInfoSC,
                    allItem[1].finalEmailSecondApproverInfoSC,
                    allItem[2].finalEmailSecondApproverInfoSC,
                    allItem[3].finalEmailSecondApproverInfoSC,
                    allItem[4].finalEmailSecondApproverInfoSC,
                    allItem[5].finalEmailSecondApproverInfoSC,
                    allItem[6].finalEmailSecondApproverInfoSC,
                    allItem[7].finalEmailSecondApproverInfoSC,
                ]);
                setPreservedTextThirdAp([
                    allItem[0].finalEmailThirdApproverInfoSC,
                    allItem[1].finalEmailThirdApproverInfoSC,
                    allItem[2].finalEmailThirdApproverInfoSC,
                    allItem[3].finalEmailThirdApproverInfoSC,
                    allItem[4].finalEmailThirdApproverInfoSC,
                    allItem[5].finalEmailThirdApproverInfoSC,
                    allItem[6].finalEmailThirdApproverInfoSC,
                    allItem[7].finalEmailThirdApproverInfoSC,
                ]);
                setPreservedTextFourthAp([
                    allItem[0].finalEmailFourthApproverInfoSC,
                    allItem[1].finalEmailFourthApproverInfoSC,
                    allItem[2].finalEmailFourthApproverInfoSC,
                    allItem[3].finalEmailFourthApproverInfoSC,
                    allItem[4].finalEmailFourthApproverInfoSC,
                    allItem[5].finalEmailFourthApproverInfoSC,
                    allItem[6].finalEmailFourthApproverInfoSC,
                    allItem[7].finalEmailFourthApproverInfoSC,
                ]);
                setPreservedTextRev([
                    allItem[0].finalEmailEdbReviewerInfoSC,
                    allItem[1].finalEmailEdbReviewerInfoSC,
                    allItem[2].finalEmailEdbReviewerInfoSC,
                    allItem[3].finalEmailEdbReviewerInfoSC,
                    allItem[4].finalEmailEdbReviewerInfoSC,
                    allItem[5].finalEmailEdbReviewerInfoSC,
                    allItem[6].finalEmailEdbReviewerInfoSC,
                    allItem[7].finalEmailEdbReviewerInfoSC,
                ]);
                setPreservedTextOwner([
                    allItem[0].finalEmailFormOwnerInfoSC,
                    allItem[1].finalEmailFormOwnerInfoSC,
                    allItem[2].finalEmailFormOwnerInfoSC,
                    allItem[3].finalEmailFormOwnerInfoSC,
                    allItem[4].finalEmailFormOwnerInfoSC,
                    allItem[5].finalEmailFormOwnerInfoSC,
                    allItem[6].finalEmailFormOwnerInfoSC,
                    allItem[7].finalEmailFormOwnerInfoSC,
                ]);
                setPreservedTextSsdo([
                    allItem[0]?.finalEmailSsdoInfo,
                    allItem[1]?.finalEmailSsdoInfo,
                    allItem[2]?.finalEmailSsdoInfo,
                    allItem[3]?.finalEmailSsdoInfo,
                    allItem[4]?.finalEmailSsdoInfo,
                    allItem[5]?.finalEmailSsdoInfo,
                    allItem[6]?.finalEmailSsdoInfo,
                    allItem[7]?.finalEmailSsdoInfo,
                ]);
                setPreservedTextSdo([
                    allItem[0]?.finalEmailSdoInfo,
                    allItem[1]?.finalEmailSdoInfo,
                    allItem[2]?.finalEmailSdoInfo,
                    allItem[3]?.finalEmailSdoInfo,
                    allItem[4]?.finalEmailSdoInfo,
                    allItem[5]?.finalEmailSdoInfo,
                    allItem[6]?.finalEmailSdoInfo,
                    allItem[7]?.finalEmailSdoInfo,
                ]);
                setPreservedTextCsdo([
                    allItem[0]?.finalEmailCsdoInfo,
                    allItem[1]?.finalEmailCsdoInfo,
                    allItem[2]?.finalEmailCsdoInfo,
                    allItem[3]?.finalEmailCsdoInfo,
                    allItem[4]?.finalEmailCsdoInfo,
                    allItem[5]?.finalEmailCsdoInfo,
                    allItem[6]?.finalEmailCsdoInfo,
                    allItem[7]?.finalEmailCsdoInfo,
                ]);
                setPreservedTextServo([
                    allItem[0]?.finalEmailServoInfo,
                    allItem[1]?.finalEmailServoInfo,
                    allItem[2]?.finalEmailServoInfo,
                    allItem[3]?.finalEmailServoInfo,
                    allItem[4]?.finalEmailServoInfo,
                    allItem[5]?.finalEmailServoInfo,
                    allItem[6]?.finalEmailServoInfo,
                    allItem[7]?.finalEmailServoInfo,
                ]);
                setPreservedTextClerStaff([
                    allItem[0]?.finalEmailClerStaffInfo,
                    allItem[1]?.finalEmailClerStaffInfo,
                    allItem[2]?.finalEmailClerStaffInfo,
                    allItem[3]?.finalEmailClerStaffInfo,
                    allItem[4]?.finalEmailClerStaffInfo,
                    allItem[5]?.finalEmailClerStaffInfo,
                    allItem[6]?.finalEmailClerStaffInfo,
                    allItem[7]?.finalEmailClerStaffInfo,
                ]);
                // setUnchangedPart(urlLinkNRefNumSC);
            } else {
                setPreservedTitle([
                    allItem[0].titleApplicant, //applicant
                    allItem[1].titleApplicant, //approver
                    allItem[2].titleApplicant, //2nd approver
                    allItem[3].titleApplicant, //3rd approver
                    allItem[4].titleApplicant, //4rd approver
                    allItem[5].titleApplicant, //reviewer])
                    allItem[6].titleApplicant, //return
                    allItem[7].titleApplicant, //reject
                ]);
                setPreservedTitleAp([
                    allItem[0].titleApprover,
                    allItem[1].titleApprover,
                    allItem[2].titleApprover,
                    allItem[3].titleApprover,
                    allItem[4].titleApprover,
                    allItem[5].titleApprover,
                    allItem[6].titleApprover,
                    allItem[7].titleApprover,
                ]);
                setPreservedTitleSecAp([
                    allItem[0].titleSecondApprover,
                    allItem[1].titleSecondApprover,
                    allItem[2].titleSecondApprover,
                    allItem[3].titleSecondApprover,
                    allItem[4].titleSecondApprover,
                    allItem[5].titleSecondApprover,
                    allItem[6].titleSecondApprover,
                    allItem[7].titleSecondApprover,
                ]);
                setPreservedTitleThirdAp([
                    allItem[0].titleThirdApprover,
                    allItem[1].titleThirdApprover,
                    allItem[2].titleThirdApprover,
                    allItem[3].titleThirdApprover,
                    allItem[4].titleThirdApprover,
                    allItem[5].titleThirdApprover,
                    allItem[6].titleThirdApprover,
                    allItem[7].titleThirdApprover,
                ]);
                setPreservedTitleFourthAp([
                    allItem[0].titleFourthApprover,
                    allItem[1].titleFourthApprover,
                    allItem[2].titleFourthApprover,
                    allItem[3].titleFourthApprover,
                    allItem[4].titleFourthApprover,
                    allItem[5].titleFourthApprover,
                    allItem[6].titleFourthApprover,
                    allItem[7].titleFourthApprover,
                ]);
                setPreservedTitleRev([
                    allItem[0].titleReviewer,
                    allItem[1].titleReviewer,
                    allItem[2].titleReviewer,
                    allItem[3].titleReviewer,
                    allItem[4].titleReviewer,
                    allItem[5].titleReviewer,
                    allItem[6].titleReviewer,
                    allItem[7].titleReviewer,
                ]);
                setPreservedTitleOwner([
                    allItem[0].titleFormOwner,
                    allItem[1].titleFormOwner,
                    allItem[2].titleFormOwner,
                    allItem[3].titleFormOwner,
                    allItem[4].titleFormOwner,
                    allItem[5].titleFormOwner,
                    allItem[6].titleFormOwner,
                    allItem[7].titleFormOwner,
                ]);
                setPreservedTitleSsdo([
                    allItem[0]?.titleSsdo,
                    allItem[1]?.titleSsdo,
                    allItem[2]?.titleSsdo,
                    allItem[3]?.titleSsdo,
                    allItem[4]?.titleSsdo,
                    allItem[5]?.titleSsdo,
                    allItem[6]?.titleSsdo,
                    allItem[7]?.titleSsdo,
                ]);
                setPreservedTitleSdo([
                    allItem[0]?.titleSdo,
                    allItem[1]?.titleSdo,
                    allItem[2]?.titleSdo,
                    allItem[3]?.titleSdo,
                    allItem[4]?.titleSdo,
                    allItem[5]?.titleSdo,
                    allItem[6]?.titleSdo,
                    allItem[7]?.titleSdo,
                ]);
                setPreservedTitleCsdo([
                    allItem[0]?.titleCsdo,
                    allItem[1]?.titleCsdo,
                    allItem[2]?.titleCsdo,
                    allItem[3]?.titleCsdo,
                    allItem[4]?.titleCsdo,
                    allItem[5]?.titleCsdo,
                    allItem[6]?.titleCsdo,
                    allItem[7]?.titleCsdo,
                ]);
                setPreservedTitleServo([
                    allItem[0]?.titleServo,
                    allItem[1]?.titleServo,
                    allItem[2]?.titleServo,
                    allItem[3]?.titleServo,
                    allItem[4]?.titleServo,
                    allItem[5]?.titleServo,
                    allItem[6]?.titleServo,
                    allItem[7]?.titleServo,
                ]);
                setPreservedTitleClerStaff([
                    allItem[0]?.titleClerStaff,
                    allItem[1]?.titleClerStaff,
                    allItem[2]?.titleClerStaff,
                    allItem[3]?.titleClerStaff,
                    allItem[4]?.titleClerStaff,
                    allItem[5]?.titleClerStaff,
                    allItem[6]?.titleClerStaff,
                    allItem[7]?.titleClerStaff,
                ]);
                //content
                setPreservedText([
                    allItem[0].finalEmailApplicantInfo,
                    allItem[1].finalEmailApplicantInfo,
                    allItem[2].finalEmailApplicantInfo,
                    allItem[3].finalEmailApplicantInfo,
                    allItem[4].finalEmailApplicantInfo,
                    allItem[5].finalEmailApplicantInfo,
                    allItem[6].finalEmailApplicantInfo,
                    allItem[7].finalEmailApplicantInfo,
                ]);
                setPreservedTextAp([
                    allItem[0].finalEmailApproverInfo,
                    allItem[1].finalEmailApproverInfo,
                    allItem[2].finalEmailApproverInfo,
                    allItem[3].finalEmailApproverInfo,
                    allItem[4].finalEmailApproverInfo,
                    allItem[5].finalEmailApproverInfo,
                    allItem[6].finalEmailApproverInfo,
                    allItem[7].finalEmailApproverInfo,
                ]);
                setPreservedTextSecAp([
                    allItem[0].finalEmailSecondApproverInfo,
                    allItem[1].finalEmailSecondApproverInfo,
                    allItem[2].finalEmailSecondApproverInfo,
                    allItem[3].finalEmailSecondApproverInfo,
                    allItem[4].finalEmailSecondApproverInfo,
                    allItem[5].finalEmailSecondApproverInfo,
                    allItem[6].finalEmailSecondApproverInfo,
                    allItem[7].finalEmailSecondApproverInfo,
                ]);
                setPreservedTextThirdAp([
                    allItem[0].finalEmailThirdApproverInfo,
                    allItem[1].finalEmailThirdApproverInfo,
                    allItem[2].finalEmailThirdApproverInfo,
                    allItem[3].finalEmailThirdApproverInfo,
                    allItem[4].finalEmailThirdApproverInfo,
                    allItem[5].finalEmailThirdApproverInfo,
                    allItem[6].finalEmailThirdApproverInfo,
                    allItem[7].finalEmailThirdApproverInfo,
                ]);
                setPreservedTextFourthAp([
                    allItem[0].finalEmailFourthApproverInfo,
                    allItem[1].finalEmailFourthApproverInfo,
                    allItem[2].finalEmailFourthApproverInfo,
                    allItem[3].finalEmailFourthApproverInfo,
                    allItem[4].finalEmailFourthApproverInfo,
                    allItem[5].finalEmailFourthApproverInfo,
                    allItem[6].finalEmailFourthApproverInfo,
                    allItem[7].finalEmailFourthApproverInfo,
                ]);
                setPreservedTextRev([
                    allItem[0].finalEmailEdbReviewerInfo,
                    allItem[1].finalEmailEdbReviewerInfo,
                    allItem[2].finalEmailEdbReviewerInfo,
                    allItem[3].finalEmailEdbReviewerInfo,
                    allItem[4].finalEmailEdbReviewerInfo,
                    allItem[5].finalEmailEdbReviewerInfo,
                    allItem[6].finalEmailEdbReviewerInfo,
                    allItem[7].finalEmailEdbReviewerInfo,
                ]);
                setPreservedTextOwner([
                    allItem[0].finalEmailFormOwnerInfo,
                    allItem[1].finalEmailFormOwnerInfo,
                    allItem[2].finalEmailFormOwnerInfo,
                    allItem[3].finalEmailFormOwnerInfo,
                    allItem[4].finalEmailFormOwnerInfo,
                    allItem[5].finalEmailFormOwnerInfo,
                    allItem[6].finalEmailFormOwnerInfo,
                    allItem[7].finalEmailFormOwnerInfo,
                ]);
                setPreservedTextSsdo([
                    allItem[0]?.finalEmailSsdoInfo,
                    allItem[1]?.finalEmailSsdoInfo,
                    allItem[2]?.finalEmailSsdoInfo,
                    allItem[3]?.finalEmailSsdoInfo,
                    allItem[4]?.finalEmailSsdoInfo,
                    allItem[5]?.finalEmailSsdoInfo,
                    allItem[6]?.finalEmailSsdoInfo,
                    allItem[7]?.finalEmailSsdoInfo,
                ]);
                setPreservedTextSdo([
                    allItem[0]?.finalEmailSdoInfo,
                    allItem[1]?.finalEmailSdoInfo,
                    allItem[2]?.finalEmailSdoInfo,
                    allItem[3]?.finalEmailSdoInfo,
                    allItem[4]?.finalEmailSdoInfo,
                    allItem[5]?.finalEmailSdoInfo,
                    allItem[6]?.finalEmailSdoInfo,
                    allItem[7]?.finalEmailSdoInfo,
                ]);
                setPreservedTextCsdo([
                    allItem[0]?.finalEmailCsdoInfo,
                    allItem[1]?.finalEmailCsdoInfo,
                    allItem[2]?.finalEmailCsdoInfo,
                    allItem[3]?.finalEmailCsdoInfo,
                    allItem[4]?.finalEmailCsdoInfo,
                    allItem[5]?.finalEmailCsdoInfo,
                    allItem[6]?.finalEmailCsdoInfo,
                    allItem[7]?.finalEmailCsdoInfo,
                ]);
                setPreservedTextServo([
                    allItem[0]?.finalEmailServoInfo,
                    allItem[1]?.finalEmailServoInfo,
                    allItem[2]?.finalEmailServoInfo,
                    allItem[3]?.finalEmailServoInfo,
                    allItem[4]?.finalEmailServoInfo,
                    allItem[5]?.finalEmailServoInfo,
                    allItem[6]?.finalEmailServoInfo,
                    allItem[7]?.finalEmailServoInfo,
                ]);
                setPreservedTextClerStaff([
                    allItem[0]?.finalEmailClerStaffInfo,
                    allItem[1]?.finalEmailClerStaffInfo,
                    allItem[2]?.finalEmailClerStaffInfo,
                    allItem[3]?.finalEmailClerStaffInfo,
                    allItem[4]?.finalEmailClerStaffInfo,
                    allItem[5]?.finalEmailClerStaffInfo,
                    allItem[6]?.finalEmailClerStaffInfo,
                    allItem[7]?.finalEmailClerStaffInfo,
                ]);
                // setUnchangedPart(urlLinkNRefNum);
            }
        } else {
            console.log("not yet loaded");
        }
    }, [i18n.language, selectedForm, allItem]);

    const inputWithLockString = (e, part, index) => {
        const ssdoCon = "(${ssdo_district})";
        const sdoCon = "(${sdo_district})";
        const csdoCon = "(${csdo_district})";
        const clericalStaffCon = "(${clerical_staff_district})";
        switch (part) {
            case "applicant": {
                if (e.target.value.indexOf(unchangedPart) == -1) {
                    e.target.value = preservedText[index];
                }
                const newText = [...preservedText];
                newText[index] = e.target.value;
                setPreservedText(newText);
                break;
            }
            case "approver": {
                if (e.target.value.indexOf(unchangedPart) == -1) {
                    e.target.value = preservedTextAp[index];
                }
                const newText = [...preservedTextAp];
                newText[index] = e.target.value;
                setPreservedTextAp(newText);
                break;
            }
            case "secondApprover": {
                if (e.target.value.indexOf(unchangedPart) == -1) {
                    e.target.value = preservedTextSecAp[index];
                }
                const newText = [...preservedTextSecAp];
                newText[index] = e.target.value;
                setPreservedTextSecAp(newText);
                break;
            }
            case "thirdApprover": {
                if (e.target.value.indexOf(unchangedPart) == -1) {
                    e.target.value = preservedTextThirdAp[index];
                }
                const newText = [...preservedTextThirdAp];
                newText[index] = e.target.value;
                setPreservedTextThirdAp(newText);
                break;
            }
            case "fourthApprover": {
                if (e.target.value.indexOf(unchangedPart) == -1) {
                    e.target.value = preservedTextFourthAp[index];
                }
                const newText = [...preservedTextFourthAp];
                newText[index] = e.target.value;
                setPreservedTextFourthAp(newText);
                break;
            }
            case "reviewer": {
                if (e.target.value.indexOf(unchangedPart) == -1) {
                    e.target.value = preservedTextRev[index];
                }
                const newText = [...preservedTextRev];
                newText[index] = e.target.value;
                setPreservedTextRev(newText);
                break;
            }
            case "formOwner": {
                if (e.target.value.indexOf(unchangedPart) == -1) {
                    e.target.value = preservedTextOwner[index];
                }
                const newText = [...preservedTextOwner];
                newText[index] = e.target.value;
                setPreservedTextOwner(newText);
                break;
            }
            case "ssdo": {
                if (
                    e.target.value.indexOf(unchangedPart) == -1 ||
                    e.target.value.indexOf(ssdoCon) == -1
                ) {
                    e.target.value = preservedTextSsdo[index];
                }
                const newText = [...preservedTextSsdo];
                newText[index] = e.target.value;
                setPreservedTextSsdo(newText);
                break;
            }
            case "sdo": {
                if (
                    e.target.value.indexOf(unchangedPart) == -1 ||
                    e.target.value.indexOf(sdoCon) == -1
                ) {
                    e.target.value = preservedTextSdo[index];
                }
                const newText = [...preservedTextSdo];
                newText[index] = e.target.value;
                setPreservedTextSdo(newText);
                break;
            }
            case "csdo": {
                if (
                    e.target.value.indexOf(unchangedPart) == -1 ||
                    e.target.value.indexOf(csdoCon) == -1
                ) {
                    e.target.value = preservedTextCsdo[index];
                }
                const newText = [...preservedTextCsdo];
                newText[index] = e.target.value;
                setPreservedTextCsdo(newText);
                break;
            }
            case "servo": {
                if (e.target.value.indexOf(unchangedPart) == -1) {
                    e.target.value = preservedTextServo[index];
                }
                const newText = [...preservedTextServo];
                newText[index] = e.target.value;
                setPreservedTextServo(newText);
                break;
            }
            case "clericalStaff": {
                if (
                    e.target.value.indexOf(unchangedPart) == -1 ||
                    e.target.value.indexOf(clericalStaffCon) == -1
                ) {
                    e.target.value = preservedTextClerStaff[index];
                }
                const newText = [...preservedTextClerStaff];
                newText[index] = e.target.value;
                setPreservedTextClerStaff(newText);
                break;
            }
            default:
                console.log("no content is changing.");
        }
    };

    const lockStringTitle = (e, part, index) => {
        switch (part) {
            case "applicant": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitle[index];
                }
                const newText = [...preservedTitle];
                newText[index] = e.target.value;
                setPreservedTitle(newText);
                break;
            }
            case "approver": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleAp[index];
                }
                const newText = [...preservedTitleAp];
                newText[index] = e.target.value;
                setPreservedTitleAp(newText);
                break;
            }
            case "secondApprover": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleSecAp[index];
                }
                const newText = [...preservedTitleSecAp];
                newText[index] = e.target.value;
                setPreservedTitleSecAp(newText);
                break;
            }
            case "thirdApprover": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleThirdAp[index];
                }
                const newText = [...preservedTitleThirdAp];
                newText[index] = e.target.value;
                setPreservedTitleThirdAp(newText);
                break;
            }
            case "fourthApprover": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleFourthAp[index];
                }
                const newText = [...preservedTitleFourthAp];
                newText[index] = e.target.value;
                setPreservedTitleFourthAp(newText);
                break;
            }
            case "reviewer": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleRev[index];
                }
                const newText = [...preservedTitleRev];
                newText[index] = e.target.value;
                setPreservedTitleRev(newText);
                break;
            }
            case "formOwner": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleOwner[index];
                }
                const newText = [...preservedTitleOwner];
                newText[index] = e.target.value;
                setPreservedTitleOwner(newText);
                break;
            }
            case "ssdo": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleSsdo[index];
                }
                const newText = [...preservedTitleSsdo];
                newText[index] = e.target.value;
                setPreservedTitleSsdo(newText);
                break;
            }
            case "sdo": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleSdo[index];
                }
                const newText = [...preservedTitleSdo];
                newText[index] = e.target.value;
                setPreservedTitleSdo(newText);
                break;
            }
            case "csdo": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleCsdo[index];
                }
                const newText = [...preservedTitleCsdo];
                newText[index] = e.target.value;
                setPreservedTitleCsdo(newText);
                break;
            }
            case "servo": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleServo[index];
                }
                const newText = [...preservedTitleServo];
                newText[index] = e.target.value;
                setPreservedTitleServo(newText);
                break;
            }
            case "clericalStaff": {
                if (e.target.value.indexOf(unchangedTitleNum) == -1) {
                    e.target.value = preservedTitleClerStaff[index];
                }
                const newText = [...preservedTitleClerStaff];
                newText[index] = e.target.value;
                setPreservedTitleClerStaff(newText);
                break;
            }
            default:
                console.log("no title is changing.");
        }
    };
    // console.log("LayerItem:" + JSON.stringify(layerItem));
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        let roleIdx = expanded
            ? parseInt(expanded.replace("panel", ""), 10)
            : undefined;
        roleIdx = isNaN(roleIdx) ? undefined : roleIdx;
        let templatePart = getIsEmailTemplateForm(
            selectedForm,
            value,
            i18n.language,
            roleIdx
        );

        let tempCon = templatePart.content;
        let tempTitle = templatePart.title;
        // console.log("tempCon====", tempCon);
        // console.log("tempTitle====", tempTitle);
        setUnchangedPart(tempCon);
        setUnchangedTitleNum(tempTitle);
    }, [i18n.language, selectedForm, value, expanded]);
    // console.log("current tab value:", value);

    const userRole = useSelector(getUserRole());

    // console.log("Watch:" + JSON.stringify(watch()));
    const approverString = role[1];
    const secondApproverString = role[2];
    const thirdApproverString = role[3];
    const fourthApproverString = role[4];
    const edbReviewerString = role[5];
    const returnApplicantString = role[6];
    const rejectString = role[7];

    function getDisabledForms(index) {
        if (
            [19, 21].includes(selectedForm) &&
            (role[index] === secondApproverString ||
                role[index] === thirdApproverString ||
                role[index] === fourthApproverString ||
                role[index] === edbReviewerString)
        ) {
            return true;
        } else if (
            selectedForm === 31 &&
            (role[index] === thirdApproverString ||
                role[index] === fourthApproverString ||
                role[index] === edbReviewerString)
        ) {
            return true;
        } else if (
            selectedForm === 101 &&
            (role[index] === edbReviewerString ||
                role[index] === returnApplicantString ||
                role[index] === rejectString)
        ) {
            return true;
        } else if (
            selectedForm === 102 &&
            role[index] === secondApproverString
        ) {
            return false;
        } else if (
            formLayerNum === 2 &&
            (role[index] === approverString ||
                role[index] === secondApproverString ||
                role[index] === thirdApproverString ||
                role[index] === fourthApproverString)
        ) {
            return true;
        } else if (
            formLayerNum === 3 &&
            (role[index] === secondApproverString ||
                role[index] === thirdApproverString ||
                role[index] === fourthApproverString)
        ) {
            return true;
        } else if (
            formLayerNum === 4 &&
            (role[index] === thirdApproverString ||
                role[index] === fourthApproverString)
        ) {
            return true;
        } else if (formLayerNum === 5 && role[index] === fourthApproverString) {
            return true;
        } else {
            return false;
        }
    }
    return (
        <Paper>
            {allItem != undefined &&
                allItem.map((item, index) =>
                    !getDisabledForms(index) ? (
                        selectedForm === 98 && index === 5 ? null : (
                            <Accordion
                                key={item.id}
                                expanded={expanded === `panel${index}`}
                                onChange={handleAccordionChange(
                                    `panel${index}`,
                                    value,
                                    index
                                )}
                                disabled={getDisabledForms(index)}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panelbh-content"
                                    id="panelbh-header"
                                >
                                    <Typography className={classes.heading}>
                                        {role[index]}
                                    </Typography>
                                    {/* <Typography className={classes.secondaryHeading}>
                                {emailRole}
                            </Typography> */}
                                </AccordionSummary>
                                <AccordionDetails
                                    style={{
                                        flexWrap: "wrap",
                                        paddingLeft: "20px",
                                    }}
                                >
                                    <Box
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                        }}
                                    >
                                        <Box>
                                            <Tabs
                                                value={value}
                                                onChange={handleChange}
                                                aria-label="Email Template Tabs"
                                                variant="scrollable"
                                                scrollButtons="auto"
                                                // allowScrollButtonsMobile
                                                style={{
                                                    width: "48rem",
                                                }}
                                            >
                                                <Tab
                                                    className={
                                                        classes.accordionTab
                                                    }
                                                    label={
                                                        selectedForm !== 98
                                                            ? t(
                                                                  "common.portal.applicant"
                                                              )
                                                            : t(
                                                                  "common.portal.roleIn98.applicant"
                                                              )
                                                    }
                                                    value={0}
                                                    {...a11yProps(0)}
                                                />
                                                {formLayerNum > 2 ? (
                                                    <Tab
                                                        className={
                                                            classes.accordionTab
                                                        }
                                                        label={
                                                            selectedForm === 98
                                                                ? t(
                                                                      "common.portal.roleIn98.approver"
                                                                  )
                                                                : selectedForm ===
                                                                  104
                                                                ? t(
                                                                      "common.portal.roleIn104.approver"
                                                                  )
                                                                : t(
                                                                      "common.portal.approver"
                                                                  )
                                                        }
                                                        {...a11yProps(1)}
                                                        value={1}
                                                        disabled={
                                                            formLayerNum > 2
                                                                ? false
                                                                : true
                                                        }
                                                    />
                                                ) : null}
                                                {index >= 1 &&
                                                (formLayerNum > 3 ||
                                                    selectedForm === 102) ? (
                                                    <Tab
                                                        className={
                                                            classes.accordionTab
                                                        }
                                                        label={
                                                            selectedForm === 98
                                                                ? t(
                                                                      "common.portal.roleIn98.secondApprover"
                                                                  )
                                                                : selectedForm ===
                                                                  102
                                                                ? t(
                                                                      "common.portal.roleIn102.secondApprover"
                                                                  )
                                                                : selectedForm ===
                                                                  104
                                                                ? t(
                                                                      "common.portal.roleIn104.secondApprover"
                                                                  )
                                                                : t(
                                                                      "common.portal.secondApprover"
                                                                  )
                                                        }
                                                        value={2}
                                                        {...a11yProps(2)}
                                                        disabled={
                                                            formLayerNum > 3 ||
                                                            selectedForm === 102
                                                                ? false
                                                                : true
                                                        }
                                                    />
                                                ) : null}
                                                {index >= 2 &&
                                                formLayerNum > 4 ? (
                                                    <Tab
                                                        className={
                                                            classes.accordionTab
                                                        }
                                                        label={
                                                            selectedForm !== 98
                                                                ? t(
                                                                      "common.portal.thirdApprover"
                                                                  )
                                                                : t(
                                                                      "common.portal.roleIn98.thirdApprover"
                                                                  )
                                                        }
                                                        value={3}
                                                        {...a11yProps(3)}
                                                        disabled={
                                                            formLayerNum > 4
                                                                ? false
                                                                : true
                                                        }
                                                    />
                                                ) : null}
                                                {index >= 3 &&
                                                formLayerNum > 5 ? (
                                                    <Tab
                                                        className={
                                                            classes.accordionTab
                                                        }
                                                        label={
                                                            selectedForm !== 98
                                                                ? t(
                                                                      "common.portal.fourthApprover"
                                                                  )
                                                                : t(
                                                                      "common.portal.roleIn98.fourthApprover"
                                                                  )
                                                        }
                                                        value={4}
                                                        {...a11yProps(4)}
                                                        disabled={
                                                            formLayerNum > 5
                                                                ? false
                                                                : true
                                                        }
                                                    />
                                                ) : null}
                                                {index >= 5 ||
                                                index == formLayerNum - 2 ||
                                                (index >= 2 &&
                                                    selectedForm === 102) ||
                                                (index == 0 &&
                                                    selectedForm === 104) ? (
                                                    <Tab
                                                        className={
                                                            classes.accordionTab
                                                        }
                                                        label={
                                                            selectedForm === 102
                                                                ? t(
                                                                      "common.portal.roleIn102.edbReviewer"
                                                                  )
                                                                : t(
                                                                      "common.portal.edbReviewer"
                                                                  )
                                                        }
                                                        value={5}
                                                        {...a11yProps(5)}
                                                    />
                                                ) : null}
                                                {index >= 5 ||
                                                index == formLayerNum - 2 ||
                                                (index >= 2 &&
                                                    selectedForm === 102) ||
                                                (index == 0 &&
                                                    selectedForm === 104) ? (
                                                    <Tab
                                                        className={
                                                            classes.accordionTab
                                                        }
                                                        label={t(
                                                            "common.portal.formOwner"
                                                        )}
                                                        value={6}
                                                        {...a11yProps(6)}
                                                    />
                                                ) : null}
                                                <Tab
                                                    className={
                                                        "titleSdo" in
                                                        watch(
                                                            `emailContent.${index}`
                                                        )
                                                            ? classes.accordionTab
                                                            : classes.hideTab
                                                    }
                                                    label={t(
                                                        "common.portal.sdo"
                                                    )}
                                                    value={8}
                                                    {...a11yProps(8)}
                                                />
                                                <Tab
                                                    className={
                                                        "titleSsdo" in
                                                        watch(
                                                            `emailContent.${index}`
                                                        )
                                                            ? classes.accordionTab
                                                            : classes.hideTab
                                                    }
                                                    label={t(
                                                        "common.portal.ssdo"
                                                    )}
                                                    value={7}
                                                    {...a11yProps(7)}
                                                />
                                                <Tab
                                                    className={
                                                        "titleCsdo" in
                                                        watch(
                                                            `emailContent.${index}`
                                                        )
                                                            ? classes.accordionTab
                                                            : classes.hideTab
                                                    }
                                                    label={t(
                                                        "common.portal.csdo"
                                                    )}
                                                    value={9}
                                                    {...a11yProps(9)}
                                                />
                                                <Tab
                                                    className={
                                                        "titleServo" in
                                                        watch(
                                                            `emailContent.${index}`
                                                        )
                                                            ? classes.accordionTab
                                                            : classes.hideTab
                                                    }
                                                    label={t(
                                                        "common.portal.servo"
                                                    )}
                                                    value={10}
                                                    {...a11yProps(10)}
                                                />
                                                <Tab
                                                    className={
                                                        "titleClerStaff" in
                                                        watch(
                                                            `emailContent.${index}`
                                                        )
                                                            ? classes.accordionTab
                                                            : classes.hideTab
                                                    }
                                                    label={t(
                                                        "common.portal.clericalStaff"
                                                    )}
                                                    value={11}
                                                    {...a11yProps(11)}
                                                />
                                            </Tabs>
                                            {/*Tab for applicant */}
                                            <TabPanel value={value} index={0}>
                                                {EnableEmailNoti(
                                                    index,
                                                    "applicant",
                                                    item,
                                                    0,
                                                    i18n.language
                                                )}
                                            </TabPanel>
                                            {/* Tab for approver */}
                                            {formLayerNum > 1 &&
                                                selectedForm !== 101 && (
                                                    <TabPanel
                                                        value={value}
                                                        index={1}
                                                    >
                                                        {EnableEmailNoti(
                                                            index,
                                                            "approver",
                                                            item,
                                                            1,
                                                            i18n.language
                                                        )}
                                                    </TabPanel>
                                                )}
                                            {/* Tab for Second Approver */}
                                            {(formLayerNum > 3 ||
                                                selectedForm === 102) && (
                                                <TabPanel
                                                    value={value}
                                                    index={2}
                                                >
                                                    {EnableEmailNoti(
                                                        index,
                                                        "secondApprover",
                                                        item,
                                                        2,
                                                        i18n.language
                                                    )}
                                                </TabPanel>
                                            )}
                                            {/* Tab for Third Approver */}
                                            {formLayerNum > 4 && (
                                                <TabPanel
                                                    value={value}
                                                    index={3}
                                                >
                                                    {EnableEmailNoti(
                                                        index,
                                                        "thirdApprover",
                                                        item,
                                                        3,
                                                        i18n.language
                                                    )}
                                                </TabPanel>
                                            )}
                                            {/* Tab for Fourth Approver */}
                                            {formLayerNum > 5 && (
                                                <TabPanel
                                                    value={value}
                                                    index={4}
                                                >
                                                    {EnableEmailNoti(
                                                        index,
                                                        "fourthApprover",
                                                        item,
                                                        4,
                                                        i18n.language
                                                    )}
                                                </TabPanel>
                                            )}
                                            {/* Tab for Edb Reviewer */}
                                            <TabPanel value={value} index={5}>
                                                {EnableEmailNoti(
                                                    index,
                                                    "reviewer",
                                                    item,
                                                    5,
                                                    i18n.language
                                                )}
                                            </TabPanel>

                                            {/* Tab for Form Owners */}
                                            <TabPanel value={value} index={6}>
                                                {EnableEmailNoti(
                                                    index,
                                                    "formOwner",
                                                    item,
                                                    6,
                                                    i18n.language
                                                )}
                                            </TabPanel>
                                            {
                                                <ReoEmailTemplate
                                                    key={item}
                                                    register={register}
                                                    watch={watch}
                                                    item={item}
                                                    index={index}
                                                    value={value}
                                                    control={control}
                                                    handleRadioChange={
                                                        handleRadioChange
                                                    }
                                                    lockStringTitle={
                                                        lockStringTitle
                                                    }
                                                    inputWithLockString={
                                                        inputWithLockString
                                                    }
                                                    unchangedPart={
                                                        unchangedPart
                                                    }
                                                    unchangedTitleNum={
                                                        unchangedTitleNum
                                                    }
                                                    errors={errors}
                                                    TabPanel={TabPanel}
                                                    indexEmailContent={watch(
                                                        `emailContent.${index}`
                                                    )}
                                                />
                                            }
                                        </Box>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        )
                    ) : null
                )}
        </Paper>
    );
}

export default EmailTemplate;
